<template>
  <div>
    <el-table
      :data="income_tax.paye"
      stripe
    >
      <el-table-column
        label="PAYE Calculation Details"
        width="360"
      >
        <template #default="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column
        label="Deductions"
        width="180"
        props="value"
      >
        <template #default="scope">
          <span v-if="scope.row.deduction">-</span><Money :amount="scope.row.deduction" />
        </template>
      </el-table-column>
      <el-table-column
        width="180"
        props="value"
      >
        <template #default="scope">
          <Money :amount="scope.row.value" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import Money from '../../shared/Money';
import{pay_run_income_tax} from '../../../api/pay_runs';
export default {
  name: 'IncomeTaxPayRun',
  components: {Money},
  props: {
    crm_user_id: {
      type: String,
      required: true
    },
    pay_period_start: {
      type: String,
      required: true
    },
    pay_period_end: {
      type: String,
      required: true
    },
    gross_payment_total: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      income_tax: [],
      net_payment: 0
    };
  },
  created(){
    this.pay_run_income_tax();
  },
  methods: {
    pay_run_income_tax() {
      if (this.income_tax.length === 0) {
        pay_run_income_tax(this, this.crm_user_id, this.pay_period_start, this.pay_period_end, this.gross_payment_total).then((response) => {
          this.income_tax = response.data[0];
          this.net_payment = Object.values(this.income_tax.paye).pop().value;
          // this.$emit('calculate_pay_run', this.net_payment);
        });
      }
    }
  }
};
</script>
<style scoped>

</style>
